<template>
  <div class="row justify-content-center">
    <div class="col align-content-center text-center">
      <img src="/assets/images/loader-real.gif" class="img-fluid" alt="">
    </div>
  </div>
</template>
<script>
export default {
  name: "loader"
}
</script>